// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7611":"407f22726ad630cd","8973":"66fb8d442a1af5a8"}[chunkId] + ".js";
};